// @flow
import _ from 'lodash';
import FileNode from '../protocol/FileNode';
import FileInfoUtil from './FileInfoUtil';
import t from '../i18n/I18n';
import System from "../basic/System";

const debug = require('../debug/debug')('wc:util:DndUtilModern');

// Nonstandard API - editors don't provide autocomplete
type FileSystemEntry = {
  isFile: boolean,
  isDirectory: boolean,
  name: string,
  fullPath: string,
  filesystem: Object,
  file: Function,
  createReader: Function
};

function browserSupportsFolderUpload(): boolean {
  return (
    window.DataTransferItem && window.DataTransferItem.prototype && window.DataTransferItem.prototype.webkitGetAsEntry
  );
}

function eventSupportsFolderUpload(e: DragEvent): boolean {
  return browserSupportsFolderUpload() && e.dataTransfer && e.dataTransfer.items;
}

async function visitFolder(entry: FileSystemEntry, absPath: string): Promise<FileNode> {
  return new Promise(async (resolve, reject) => {
    const folder = new FileNode({
      type: 'folder',
      file: {
        name: entry.name,
        type: 'folder',
        path: absPath
      },
      children: []
    });

    if (!System.isDesktop()) {

      // Get the FileSystemEntry objects from the reader.
      const entries: FileSystemEntry[] = await new Promise((resolve, reject) => {
        const reader = entry.createReader();
        let entries = [];

        const readChunk = () => {
          return new Promise((resolve, reject) => {
            reader.readEntries((chunk: FileSystemEntry[]) => {
              entries = entries.concat(chunk);
              if (chunk.length) {
                readChunk()
                  .then(resolve)
                  .catch(reject);
              } else {
                resolve(entries);
              }
            });
          });
        };

        readChunk()
          .then(resolve)
          .catch(reject);
      });

      // Recursively visit the FileSystemEntry objects.
      const fileNodePromises = entries.map(visit);

      Promise.all(fileNodePromises)
        .then((fileNodes: FileNode[]) => {
          folder.children = _.compact(fileNodes);
          resolve(folder);
        })
        .catch((err) => {
          reject(err);
        });
    } else {
      resolve(folder);
    }
  });

}

async function visitFile(entry: FileSystemEntry): Promise<FileNode> {
  const file: File = await new Promise((resolve) => entry.file((file) => resolve(file)));

  return new FileNode({
    type: 'file',
    file
  });
}

async function visit(entry: FileSystemEntry, absPath: string): Promise<FileNode> {
  if (!entry) {
    debug('[processFilesAndFolders()] entry is null. continue.');
    return null;
  }

  if (_.includes(FileInfoUtil.ignoreFileNames, entry.name)) {
    return null;
  }

  return entry.isFile ? visitFile(entry) : visitFolder(entry, absPath);
}

export async function getFileNodesFromDropEvent(e: DragEvent) {
  if (!canUseModernUploader(e)) {
    throw new Error(t('BROWSER_NOT_SUPPORT_UPLOAD_APIS'));
  }
  console.log("Path os " + e.dataTransfer.files[0].path);

  const promises = [...e.dataTransfer.items].map((item, index) => {
    const entry = item.webkitGetAsEntry();
    const absPath = e.dataTransfer.files[index].path;
    return visit(entry, absPath);
  });

  const entries: FileNode[] = await Promise.all(promises);
  return _.compact(entries);
}

export function canUseModernUploader(e: DragEvent): boolean {
  const r: any = eventSupportsFolderUpload(e);
  if (r != undefined && r != null) {
    return true;
  }
  return false;
}
